import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Restaumatic$dForm$dEditAsString from "../Restaumatic.Form.EditAsString/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dFormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic$dForm$dQuery from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic$dForm$dTotality from "../Restaumatic.Form.Totality/index.js";
import * as Restaumatic$dForm$dWidgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dPrelude$dSpecularExtra from "../Restaumatic.Prelude.SpecularExtra/index.js";
import * as Restaumatic$dServices$dPromotions from "../Restaumatic.Services.Promotions/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dFRP$dAsync from "../Specular.FRP.Async/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
const makeEmpty = /* #__PURE__ */ Restaumatic$dForm$dFormField.unsafeNewEmptyFormField(Restaumatic$dForm$dTotality.isTotalityPartial)({name: []});
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const defineForm = /* #__PURE__ */ Specular$dFRP$dHost.liftHost(Specular$dDom$dBuilder.monadCleanupBuilder)(Specular$dInternal$dRIO.monadEffectRIO);
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Specular$dInternal$dRIO.monadEffectRIO);
const query = /* #__PURE__ */ Restaumatic$dForm$dQuery.queryWith(/* #__PURE__ */ Restaumatic$dForm$dFormField.queryFormField$p(Type$dEquality.refl))(Restaumatic$dForm$dQuery.Strict);
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const newRef = /* #__PURE__ */ Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO);
const performEvent = /* #__PURE__ */ Specular$dFRP$dAsync.performEvent(monadFRP);
const holdWeakDyn = /* #__PURE__ */ Specular$dFRP$dWeakDynamic.holdWeakDyn(monadFRP);
const subscribeEvent_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeNode(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dDom$dBuilder.monadCleanupBuilder);
const weakDynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.weakDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const onlySuccess = v => {
  if (v._2.tag === "Promotions") { return Data$dMaybe.$Maybe("Just", Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(v._1, v._2._1.promotions))); }
  return Data$dMaybe.Nothing;
};
const errorMessage = v => {
  if (v.tag === "Promotions") { return Specular$dInternal$dRIO.pureImpl(); }
  if (v.tag === "InvalidCoupon") {
    return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["alert", "alert-danger"])])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.coupon.invalid),
      {}
    )));
  }
  if (v.tag === "NetworkError") {
    return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["alert", "alert-danger"])])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.coupon.fetch_error),
      {}
    )));
  }
  $runtime.fail();
};
const couponInputField = formDisabled => {
  const $0 = Specular$dInternal$dRIO.bindImpl(makeEmpty)(codeInputField => Specular$dInternal$dRIO.bindImpl(defineForm((() => {
    const $0 = Restaumatic$dForm$dFinal.applicativeFinal.pure("");
    return codeInputField.defaultValue._2(_old => $0);
  })()))(() => Specular$dInternal$dRIO.bindImpl(newEvent)(addCoupon => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("form")([
    Specular$dDom$dElement.class_("input-append coupon-input"),
    Restaumatic$dPrelude$dSpecularExtra.onSubmitPreventDefault_(v => {
      const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(query(codeInputField)));
      return () => {
        const m_code = $0();
        return for_(m_code)(code => addCoupon.fire(code))();
      };
    })
  ])(Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dWidgets.genericTextInput(Restaumatic$dForm$dFormField.isTextFieldFormField$p(Restaumatic$dForm$dEditAsString.editAsStringString))("input")(Specular$dDom$dElement.bindValueOnChange)([
    Specular$dDom$dElement.attr("id")("cart-coupon-code"),
    Specular$dDom$dElement.class_("form-control form-control--inline"),
    Specular$dDom$dElement.attr("placeholder")(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart_items.coupon_item.placeholder),
      {}
    ))
  ])(codeInputField))(() => Specular$dDom$dElement.el("button")([
    Specular$dDom$dElement.class_("btn btn-default"),
    Specular$dDom$dElement.attr("type")("submit"),
    Specular$dDom$dElement.attrWhenD(formDisabled)("disabled")("disabled")
  ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.menu.add), {}))))))(() => Specular$dInternal$dRIO.pureImpl(addCoupon.event)))));
  return env => {
    const $1 = {...env, userEnv: undefined};
    return $0($1);
  };
};
const couponInputWidget = v => v1 => {
  if (v.couponCode.tag === "Just") {
    const $0 = v.couponCode._1;
    return Specular$dDom$dElement.el("li")([Specular$dDom$dElement.classes(["item", "promotion", "item--group"])])(Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.classes(["cart-multi-column", "mobile"])
    ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["column", "info"])])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
      Specular$dDom$dElement.class_("name")
    ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.coupon_promotion.default_name),
      {}
    ))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dDom$dElement.el("p")([Specular$dDom$dElement.class_("description")])(Specular$dDom$dElement.text($0))))))(() => Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.classes(["column", "subtotal"])
    ])(Specular$dDom$dElement.el("button")([
      Specular$dDom$dElement.class_("btn btn-default"),
      Specular$dDom$dElement.attr("type")("button"),
      Specular$dDom$dElement.onClick_(v1(Data$dMaybe.Nothing))
    ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.menu.remove),
      {}
    )))))));
  }
  return Specular$dDom$dElement.el("li")([Specular$dDom$dElement.classes(["item", "promotion"])])(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.classes(["cart-multi-column", "mobile"])
  ])(Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(v4 => v4.promotionsService)(Specular$dDom$dBuilder.monadAskBuilder.ask))(backend => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBuilder.monadAskBuilder.ask)(v4 => {
    const $0 = v4.menuConsumer;
    const $1 = v4.restaurantId;
    return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["column", "info"])])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("label")([
      Specular$dDom$dElement.attr("for")("cart-coupon-code"),
      Specular$dDom$dElement.class_("control-label")
    ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.coupon_promotion.default_name),
      {}
    ))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dInternal$dRIO.bindImpl(newRef(false))(requestInProgressRef => Specular$dInternal$dRIO.bindImpl(couponInputField(requestInProgressRef._1))(newCouponE => Specular$dInternal$dRIO.bindImpl(performEvent(Specular$dFRP$dBase.functorEvent.map(couponCode => Effect$dAff._map(Data$dTuple.Tuple(couponCode))(Restaumatic$dServices$dPromotions.getActivePromotionsAndDecode($1)($0)([
      couponCode
    ])(backend)))(newCouponE)))(responseE => Specular$dInternal$dRIO.bindImpl(holdWeakDyn(responseE))(responseDyn => Specular$dInternal$dRIO.bindImpl(subscribeEvent_(x => requestInProgressRef._2(_old => x))(Specular$dFRP$dBase.leftmost([
      Specular$dFRP$dBase.functorEvent.map(v$1 => true)(newCouponE),
      Specular$dFRP$dBase.functorEvent.map(v$1 => false)(responseE)
    ])))(() => Specular$dInternal$dRIO.bindImpl(weakDynamic_(Specular$dFRP$dBase.functorDynamic.map(v1$1 => {
      if (v1$1.tag === "Just") { return Data$dMaybe.$Maybe("Just", errorMessage(v1$1._1._2)); }
      return Data$dMaybe.Nothing;
    })(responseDyn)))(() => subscribeEvent_(v1)(Specular$dFRP$dBase.filterMapEvent(onlySuccess)(responseE)))))))))));
  }))));
};
export {
  couponInputField,
  couponInputWidget,
  defineForm,
  errorMessage,
  for_,
  holdWeakDyn,
  makeEmpty,
  monadFRP,
  newEvent,
  newRef,
  onlySuccess,
  performEvent,
  query,
  subscribeEvent_,
  weakDynamic_
};
